import './MePoint.css';
import logo from './../../images/logo-2.svg';
const MePoint = ({ translations, isFullScreenMode }) => {
    return (
        <div className='me__point'>
            <div className='me__point_items'>
                <img
                    className={
                        isFullScreenMode
                            ? 'me__point_logo_full'
                            : 'me__point_logo'
                    }
                    src={logo}
                />
                <div className='me__point_links'>
                    <a className='me__point_link' href='#'>
                        {translations.privacyPolicy}
                    </a>
                    <a className='me__point_link' href='#'>
                        {translations.terms}
                    </a>
                    <div className='me__point_link'>
                        <a href='#'>{translations.contacts}</a>
                        <a
                            href='mailto:mepointapp@gmail.com'
                            target='_blank'
                            rel='noopener'
                        >
                            email - mepointapp@gmail.com
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MePoint;
